import { render, staticRenderFns } from "./reply-item.vue?vue&type=template&id=5a5666e6&scoped=true&"
import script from "./reply-item.vue?vue&type=script&lang=js&"
export * from "./reply-item.vue?vue&type=script&lang=js&"
import style0 from "./reply-item.vue?vue&type=style&index=0&id=5a5666e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5666e6",
  null
  
)

export default component.exports